import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Redirect } from 'react-router-dom';
import PhoneInput from 'react-phone-number-input';
import Select from 'react-select';
import { api_crud_base, api_crud_route, data_interface, endpoints } from './Config';
import { getTokenInfo } from '../../../../UseToken';
import Loader from '../../../Loader/Loader';
import Swal from 'sweetalert2'
import Hosts from '../../../../Hosts';
import {
	reqGET,
	reqPOST,
	reqDELETE,
	reqPUT,
	reqFILE,
	obter_paises_em_pt,
	pattern_email,
	handle_compressed_image_upload,
	set_language
} from '../../../../Utils';

import { language } from './Language';
import { color } from '../../../WEBContent/Color';

const modalStyles = {
	modalOverlay: {
		position: 'fixed',
		top: 0,
		left: 0,
		width: '100%',
		height: '100%',
		backgroundColor: color.corShadow.rgba2,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		zIndex: 1000,
	},
	modalContent: {
		backgroundColor: color.cor3.hexa,
		padding: '20px',
		borderRadius: '10px',
		width: '600px',
		maxWidth: '90%',
		textAlign: 'center',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		position: 'relative',
		overflow: 'hidden',
	},
	taskListContainer: {
		flex: 1,
		width: '100%',
		padding: '10px 15px',
		textAlign: 'start',
	},
	buttonContainer: {
		width: '100%',
		display: 'flex',
		justifyContent: 'center',
		marginTop: '15px',
	},
	closeButton: {
		padding: '10px 20px',
		border: 'none',
		borderRadius: '5px',
		cursor: 'pointer',
		backgroundColor: color.cor1.hexa,
		fontSize: '16px',
	},
};

// Modalidades — mesma lista usada no módulo dos Clubes
const modalidades_lista = [
	{ value: 'ski_de_fundo', label: 'Esqui de Fundo' },
	{ value: 'curling', label: 'Curling' },
	{ value: 'ski_alpino', label: 'Esqui Alpino' },
	{ value: 'bobsled', label: 'Bobsled' },
	{ value: 'hoquei_no_gelo', label: 'Hóquei no Gelo' },
	{ value: 'luge', label: 'Luge' },
	{ value: 'snowboard', label: 'Snowboard' },
	{ value: 'skeleton', label: 'Skeleton' },
	{ value: 'patinagem_artistica', label: 'Patinagem Artística' },
	{ value: 'patinagem_de_velocidade', label: 'Patinagem de Velocidade' },
	{ value: 'ski_freestyle', label: 'Esqui Free Style' },
	{ value: 'biatlo', label: 'Biatlo' },
];

const tipo_competicao_lista = [
	{ value: 'campeonato_nacional', label: 'Campeonato Nacional' },
	{ value: 'campeonato_regional', label: 'Campeonato Regional' },
	{ value: 'taca', label: 'Taça' },
	{ value: 'torneio', label: 'Torneio' },
	{ value: 'internacional', label: 'Internacional' },
	{ value: 'outro', label: 'Outro' },
];

// Nota: escaloes_lista (opções do multi-select) é construída mais abaixo,
// depois de definidas as tabelas ESCALOES_GERAL / SNOWBOARD / PATINAGEM —
// junta os 3 grupos, porque uma competição pode ter modalidades cujos
// escalões usam IDs diferentes (ex.: snowboard usa "U18_ROOKIE", não "U18").

// ================= CÁLCULO DE ESCALÃO (idade) =================
// Mesma lógica usada no módulo das entidades — determina o escalão de um
// atleta a partir da data de nascimento e da(s) modalidade(s) que pratica.
const ESCALOES_GERAL = [
	{ id: 'U10', label: 'U10', min: 2016, max: Infinity },
	{ id: 'U12', label: 'U12', min: 2014, max: 2015 },
	{ id: 'U14', label: 'U14', min: 2012, max: 2013 },
	{ id: 'U16', label: 'U16', min: 2010, max: 2011 },
	{ id: 'U18', label: 'U18', min: 2008, max: 2009 },
	{ id: 'U21', label: 'U21', min: 2005, max: 2007 },
	{ id: 'SENIOR', label: 'Sénior', min: 1991, max: 2004 },
	{ id: 'M35', label: 'M35', min: 1971, max: 1990 },
	{ id: 'M55', label: 'M55', min: -Infinity, max: 1970 },
];

const ESCALOES_SNOWBOARD = [
	{ id: 'U9', label: 'U9 (kids)', min: 2017, max: Infinity },
	{ id: 'U11', label: 'U11 (SuperGrom)', min: 2015, max: 2016 },
	{ id: 'U13', label: 'U13 (SuperGrom)', min: 2013, max: 2014 },
	{ id: 'U15', label: 'U15 (Grom)', min: 2011, max: 2012 },
	{ id: 'U18_ROOKIE', label: 'U18 (Rookie)', min: 2008, max: 2010 },
	{ id: 'ABSOLUTO', label: 'Absoluto', min: 1985, max: 2007 },
	{ id: 'M40', label: 'M40 (Master)', min: -Infinity, max: 1984 },
];

const ESCALOES_PATINAGEM = [
	{ id: 'PRE_INICIADO', label: 'Pré-Iniciado' },
	{ id: 'NOVATOS', label: 'Novatos' },
	{ id: 'JUNIORES', label: 'Juniores' },
	{ id: 'SENIORES', label: 'Seniores' },
	{ id: 'ADULTOS', label: 'Adultos' },
];

// Opções do multi-select "Escalão(ões)" da competição — junta os 3 grupos,
// já que cada modalidade pode usar uma tabela de escalões diferente (os IDs
// não colidem entre grupos, confirmado: U10/U12/... vs U9/U11/.../U18_ROOKIE
// vs PRE_INICIADO/NOVATOS/...).
const escaloes_lista = [
	...ESCALOES_GERAL.map(e => ({ value: e.id, label: e.label })),
	...ESCALOES_SNOWBOARD.map(e => ({ value: e.id, label: `${e.label} (Snowboard)` })),
	...ESCALOES_PATINAGEM.map(e => ({ value: e.id, label: `${e.label} (Patinagem)` })),
];

const anoNascimento = (birthday) => {
	if (!birthday) return null;
	const ano = parseInt(String(birthday).slice(0, 4), 10);
	return Number.isNaN(ano) ? null : ano;
};

const escalaoPorAno = (ano, tabela) => {
	if (ano === null) return '';
	const item = tabela.find(e => ano >= e.min && ano <= e.max);
	return item ? item.id : '';
};

// Idade de referência = idade que o atleta tem a 1 de julho do ano em que a época começa
const idadeReferencia = (birthday, anoEpoca) => {
	if (!birthday) return null;
	const nascimento = new Date(birthday);
	const referencia = new Date(anoEpoca, 6, 1);
	let idade = referencia.getFullYear() - nascimento.getFullYear();
	const diffMes = referencia.getMonth() - nascimento.getMonth();
	if (diffMes < 0 || (diffMes === 0 && referencia.getDate() < nascimento.getDate())) idade--;
	return idade;
};

const escalaoPorIdade = (idade) => {
	if (idade === null) return '';
	if (idade >= 28) return 'ADULTOS';
	if (idade > 13 && idade <= 18) return 'JUNIORES';
	if (idade >= 8 && idade <= 13) return 'NOVATOS';
	if (idade >= 17) return 'SENIORES';
	if (idade >= 6) return 'PRE_INICIADO';
	return '';
};

const detectarGrupoModalidade = (modalidade_value) => {
	const v = (modalidade_value ?? '').toString().toLowerCase();
	if (v.includes('patinacao')) return 'patinagem';
	if (v.includes('snowboard')) return 'snowboard';
	return 'geral';
};

const getAnoEpocaAtual = () => {
	const hoje = new Date();
	const anoAtual = hoje.getFullYear();
	const mesAtual = hoje.getMonth();
	return mesAtual >= 6 ? anoAtual : anoAtual - 1;
};

// Devolve o escalão calculado de uma entidade (atleta), para uma dada modalidade (valor único)
const calcular_escalao_para_modalidade = (entidade, modalidade_value) => {
	const birthday = entidade?.info?.birthday ?? entidade?.birthday
	const grupo = detectarGrupoModalidade(modalidade_value)
	const anoEpoca = getAnoEpocaAtual()

	if (grupo === 'patinagem') {
		return escalaoPorIdade(idadeReferencia(birthday, anoEpoca))
	}
	const tabela = grupo === 'snowboard' ? ESCALOES_SNOWBOARD : ESCALOES_GERAL
	return escalaoPorAno(anoNascimento(birthday), tabela)
};

// Modalidades que a entidade pratica (array de valores, aceita formatos aninhado/achatado)
const get_modalidades_entidade = (entidade) => {
	const mods = entidade?.info?.modalidades ?? entidade?.modalidades
	return Array.isArray(mods) ? mods.map(m => (m.value ?? m)) : []
};

// Modalidades em comum entre a entidade e a competição. Se a competição não
// tiver modalidades definidas, devolve todas as que a entidade pratica.
const get_overlapping_modalidades = (entidade, modalidades_competicao) => {
	const mods_entidade = get_modalidades_entidade(entidade)
	if (!modalidades_competicao || modalidades_competicao.length === 0) return mods_entidade
	return mods_entidade.filter(m => modalidades_competicao.includes(m))
};

// Verifica se a entidade pratica pelo menos uma das modalidades da competição
const entidade_pratica_modalidade = (entidade, modalidades_competicao) => {
	if (!modalidades_competicao || modalidades_competicao.length === 0) return true
	return get_overlapping_modalidades(entidade, modalidades_competicao).length > 0
};

// Escalão da entidade, calculado a partir da primeira modalidade em comum com a competição
const calcular_escalao_entidade = (entidade, modalidades_competicao) => {
	const overlapping = get_overlapping_modalidades(entidade, modalidades_competicao)
	return calcular_escalao_para_modalidade(entidade, overlapping[0])
};

// Verifica se a entidade está em algum dos escalões da competição, considerando
// todas as modalidades em comum (cada modalidade pode implicar um escalão diferente)
const entidade_esta_no_escalao = (entidade, modalidades_competicao, escaloes_competicao) => {
	if (!escaloes_competicao || escaloes_competicao.length === 0) return true
	const overlapping = get_overlapping_modalidades(entidade, modalidades_competicao)
	if (overlapping.length === 0) return false
	return overlapping.some(m => escaloes_competicao.includes(calcular_escalao_para_modalidade(entidade, m)))
};


export default function Regist(props) {
	const [, set_dados] = useState(null);
	const dados = useRef(null);

	const [lang, set_lang] = useState('pt');

	const [isloading, setLoading] = useState(true);
	const [isRedirect, setRedirect] = useState(false);
	const [refresh, setRefresh] = useState(0);

	const [show_delete_button, set_show_delete_button] = useState(false);
	const [is_edit, set_is_edit] = useState(false);

	const [countries, set_countries] = useState([]);

	// Documento (Regulamento)
	const [files_doc, set_files_doc] = useState([]);
	const [img_loader, set_img_loader] = useState([]);

	// ===== Modal "Inscrever Clube" =====
	const [showClubeModal, setShowClubeModal] = useState(false);
	const [clubeSearch, setClubeSearch] = useState('');
	const [clubeResults, setClubeResults] = useState([]);
	const [clubeLoading, setClubeLoading] = useState(false);
	const [selectedClubeToInscrever, setSelectedClubeToInscrever] = useState(null);

	// ===== Modal "Inscrever Atletas" =====
	const [showAtletaModal, setShowAtletaModal] = useState(false);
	const [atletaSearch, setAtletaSearch] = useState(''); { console.log('atletaSearch', atletaSearch) }
	const [atletaResults, setAtletaResults] = useState([]); { console.log('atletaResults', atletaResults) }
	const [atletaLoading, setAtletaLoading] = useState(false); { console.log('atletaLoading', atletaLoading) }
	const [selectedAtletaToInscrever, setSelectedAtletaToInscrever] = useState(null); { console.log('selectedAtletaToInscrever', selectedAtletaToInscrever) }
	const [selected_clube_inscrito, set_selected_clube_inscrito] = useState(null); { console.log('selected_clube_inscrito', selected_clube_inscrito) }

	// IDs de todas as entidades que são Clube — usado para excluir clubes da
	// pesquisa de Atletas (a pesquisa de atletas usa a lista "todas as entidades",
	// por isso precisamos desta lista à parte para filtrar quem NÃO é clube).
	const [clube_ids, set_clube_ids] = useState(new Set());

	const fetch_clube_ids = async () => {
		try {
			const res = await reqGET(`${Hosts.SIMCore_API}/entities/list/${getTokenInfo().companycode}/Clube`)
			set_clube_ids(new Set((res.data || []).map(e => String(e.id))))
		} catch (error) {
			console.error('Erro ao carregar lista de clubes:', error)
		}
	}

	useEffect(() => {
		fetch_clube_ids()
	}, [])

	// Garante que todos os campos usados pelo formulário existem, mesmo que o
	// data_interface do Config.js ainda não os tenha definidos.
	const ensure_defaults = (d) => {
		const address_defaults = {
			localidade: '',
			country: '',
			address_detail: '',
		}

		if (!Array.isArray(d.addresses) || d.addresses.length === 0) {
			d.addresses = [{}]
		}
		d.addresses[0] = { ...address_defaults, ...d.addresses[0] }
		// O backend pode devolver estes campos como null (não '') quando estão
		// vazios — um <input value={null}> fica "descontrolado" no React e
		// deixa de reagir a escrita. Por isso normalizamos null/undefined aqui.
		Object.keys(address_defaults).forEach(k => {
			if (d.addresses[0][k] === null || d.addresses[0][k] === undefined) {
				d.addresses[0][k] = address_defaults[k]
			}
		})

		const info_defaults = {
			name: '',
			tipo_competicao: '',
			modalidades: [],
			escaloes: [],
			epoca: '',
			data_inicio: '',
			data_fim: '',
			regulamento: [],
			observacoes: '',
			clubes_inscritos: [],
			atletas_inscritos: [],
			classificacoes: {},
			// O backend guarda os dados do responsável num objeto aninhado
			// (info.responsavel = { identificacao, telefone, email }), não em
			// três chaves soltas — por isso o valor por omissão tem de ser
			// também um objeto aninhado.
			responsavel: {
				identificacao: '',
				telefone: '',
				email: '',
			},
		}
		d.info = { ...info_defaults, ...d.info }
		Object.keys(info_defaults).forEach(k => {
			if (d.info[k] === null || d.info[k] === undefined) {
				d.info[k] = info_defaults[k]
			}
		})

		// Junta o objeto "responsavel" com os defaults (caso o backend só
		// devolva alguns dos 3 campos, ou nenhum) e normaliza null/undefined.
		d.info.responsavel = { ...info_defaults.responsavel, ...(d.info.responsavel || {}) }
		Object.keys(info_defaults.responsavel).forEach(k => {
			if (d.info.responsavel[k] === null || d.info.responsavel[k] === undefined) {
				d.info.responsavel[k] = ''
			}
		})

		return d
	}

	const clean_data = () => {
		set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
		set_dados(dados.current.info.companycode = getTokenInfo().companycode)
		set_dados(dados.current = ensure_defaults(dados.current))
	}

	const fetch_id_info = async (id_serch) => {
		return await reqGET(`${api_crud_route}/${getTokenInfo().companycode}/${id_serch}`)
			.then(res => {
				set_dados(dados.current = ensure_defaults(res.data[0]));
			})
			.catch(error => console.log(error))
	}

	// NOTA IMPORTANTE: este efeito corria com `[props]` como dependência.
	// O objeto `props` é recriado pelo router em cada render do componente
	// pai, mesmo sem nada de relevante mudar. Isso fazia o React correr a
	// função de cleanup (`clean_data()`) e depois voltar a executar o efeito
	// inteiro — apagando tudo o que o utilizador tinha escrito no formulário
	// (endereço, responsável, etc.) sempre que houvesse um re-render externo,
	// mesmo a meio da edição. Passamos a depender só do id/operation, que só
	// mudam quando de facto navegamos para outro registo.
	const item_id = props?.location?.state?.item?.id
	const operation = props?.location?.state?.operation

	useEffect(() => {
		clean_data();

		set_lang(localStorage.getItem('lang'))

		obter_paises_em_pt(set_countries)

		if (operation === 'edit' && item_id) {
			set_is_edit(true)
			set_show_delete_button(true)

			fetch_id_info(item_id).then(() => {
				setLoading(false)
			})
			return
		}

		clean_data()
		setLoading(false);
		setRedirect(false);

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [item_id, operation])

	const handle_change_info = (e) => {
		const { name, value } = e.target;
		set_dados(dados.current.info[name] = value)
	}

	// Handler dedicado para os campos do responsável, que agora vivem dentro
	// de info.responsavel (objeto aninhado), e não soltos em info.*
	const handle_change_responsavel = (e) => {
		const { name, value } = e.target;
		set_dados(dados.current.info.responsavel[name] = value)
	}

	const handle_change_addresses = (e, addresses_index = 0) => {
		const { name, value } = e.target;
		set_dados(dados.current.addresses[addresses_index][name] = value)
	}

	const change_country = (e) => {
		set_dados(dados.current.addresses[0].country = e.value);
	}

	const change_modalidades = (selected) => {
		set_dados(dados.current.info.modalidades = selected || []);
	};

	const change_tipo_competicao = (selected) => {
		set_dados(dados.current.info.tipo_competicao = selected ? selected.value : '');
	};

	const change_escaloes = (selected) => {
		set_dados(dados.current.info.escaloes = selected || []);
	};


	// ================= REGULAMENTO (PDF) =================
	const uploadFile = async (file, field) => {
		const formData = new FormData()
		formData.append('files', file)
		formData.append('id', dados.current.id)
		formData.append('file_name', file.name)
		formData.append('type', 'content')
		formData.append('companycode', dados.current.info.companycode)
		formData.append('folder', Hosts.APP_REPO_FOLDER + 'upload/content/');

		return await reqFILE(`${api_crud_base}/multimedia/file`, formData)
			.then((res) => {
				const file_meta = {
					name: file.name,
					type: file.type,
					size: file.size,
					path: res.data.path,
					source_name: res.data.name,
					link: res.data.path + '' + res.data.name,
				};

				set_dados(dados.current.info[field] = [file_meta]);

				reqPUT(`${api_crud_route}/${getTokenInfo().companycode}`, dados.current)
					.then(() => { })
					.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))

				return true
			})
			.catch(erro => console.log('Erro POST File: ' + erro))
	}

	const onChangeHandlerFilesDoc = (e) => {
		const { files, dataset } = e.target;
		const { field } = dataset;

		let filesArray = Array.prototype.slice.call(files);
		let storedFiles = [];

		filesArray.forEach((v) => {
			if ((v.type.includes('/pdf')) && (v.size < 10485760)) {
				storedFiles.push(v);
			}
			else {
				Swal.fire((language[lang].upload_file_error ?? 'Formato do ficheiro incorrecto: ') + v.name, '', 'info')
			}
		});

		if (storedFiles.length > 0) {
			let files_aux = files_doc
			files_aux.push({ files: storedFiles, field: field })
			set_files_doc(files_aux)
			setRefresh(refresh + 1)
		}
	}

	const uploadFilesDoc = async (files, field) => {
		files.forEach((element) => {
			if (element.type === 'application/pdf') {
				uploadFile(element, field).then(() => { })
			}
			else {
				Swal.fire('Formato do ficheiro incorrecto!', '', 'info')
			}
		})
	}

	const handleDocRemove = (field) => {
		set_dados(dados.current.info[field] = [])
		setRefresh(refresh + 1)
	};

	// ================= CLUBES INSCRITOS =================
	const search_clubes_to_inscrever = async (term) => {
		setClubeLoading(true)
		try {
			const res = await reqGET(`${Hosts.SIMCore_API}/entities/list/${getTokenInfo().companycode}/Clube`)
			const t = (term || '').toLowerCase()
			const ja_inscritos = (dados.current.info.clubes_inscritos || []).map(c => String(c.id))
			const filtered = (res.data || [])
				.filter(e => !ja_inscritos.includes(String(e.id)))
				.filter(e => {
					const nome = (e?.info?.name ?? e?.name ?? '').toLowerCase()
					return t === '' || nome.includes(t)
				})
			setClubeResults(filtered)
		} catch (error) {
			console.error('Erro ao pesquisar clubes:', error)
		} finally {
			setClubeLoading(false)
		}
	}

	useEffect(() => {
		if (showClubeModal) {
			search_clubes_to_inscrever(clubeSearch)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [showClubeModal])

	const handle_clube_search_change = (e) => {
		const value = e.target.value
		setClubeSearch(value)
		search_clubes_to_inscrever(value)
	}

	const handleCloseClubeModal = () => {
		setShowClubeModal(false)
		setSelectedClubeToInscrever(null)
		setClubeSearch('')
	}

	const inscrever_clube = () => {
		if (!selectedClubeToInscrever) return

		const nome_clube = selectedClubeToInscrever?.info?.name ?? selectedClubeToInscrever?.name ?? ''

		Swal.fire({
			title: language[lang].inscrever_clube_title ?? 'Inscrever clube',
			html: `${language[lang].inscrever_clube_text ?? 'Confirma inscrever o clube'} <b>${nome_clube}</b> ${language[lang].inscrever_clube_text_2 ?? 'nesta competição?'}`,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].associar_confirm ?? 'Inscrever',
			cancelButtonText: language[lang].associar_cancel ?? 'Cancelar'
		}).then((result) => {
			if (result.isConfirmed) {
				const atual = dados.current.info.clubes_inscritos || []
				set_dados(dados.current.info.clubes_inscritos = [
					...atual,
					{ id: selectedClubeToInscrever.id, label: nome_clube }
				])
				handleCloseClubeModal()
			}
		})
	}

	const remover_clube_inscrito = (clube_id) => {
		Swal.fire({
			title: language[lang].remove_title ?? 'Remover',
			text: language[lang].remove_text ?? 'Confirma remover este clube da competição?',
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].remove_confirm ?? 'Remover',
			cancelButtonText: language[lang].remove_cancel ?? 'Cancelar'
		}).then((result) => {
			if (result.isConfirmed) {
				set_dados(dados.current.info.clubes_inscritos = (dados.current.info.clubes_inscritos || []).filter(c => String(c.id) !== String(clube_id)))

				const aux = { ...(dados.current.info.classificacoes || {}) }
				delete aux[clube_id]
				set_dados(dados.current.info.classificacoes = aux)

				if (String(selected_clube_inscrito?.id) === String(clube_id)) {
					set_selected_clube_inscrito(null)
				}
			}
		})
	}

	// ================= ATLETAS INSCRITOS =================
	const search_atletas_to_inscrever = async (term) => {
		// sem clube selecionado não há o que pesquisar
		if (!selected_clube_inscrito) {
			setAtletaResults([])
			return
		}

		setAtletaLoading(true)
		try {
			const res = await reqGET(`${Hosts.SIMCore_API}/entities/special/${getTokenInfo().companycode}/*`)
			const t = (term || '').toLowerCase()
			const ja_inscritos = (dados.current.info.atletas_inscritos || []).map(a => String(a.id))
			const modalidades_competicao = (dados.current.info.modalidades || []).map(m => m.value ?? m)
			const escaloes_competicao = (dados.current.info.escaloes || []).map(esc => esc.value ?? esc)

			const filtered = (res.data || [])
				.filter(e => !ja_inscritos.includes(String(e.id)))
				.filter(e => !clube_ids.has(String(e.id)))
				// só atletas do clube selecionado (compara por id, com fallback para label)
				.filter(e => {
					const clube_entidade = e?.info?.clube ?? e?.clube
					const clube_entidade_id = clube_entidade?.id ?? clube_entidade
					const clube_entidade_label = clube_entidade?.label
					return String(clube_entidade_id) === String(selected_clube_inscrito.id)
						|| (clube_entidade_label && clube_entidade_label === selected_clube_inscrito.label)
				})
				.filter(e => {
					const nome = (e?.info?.name ?? e?.name ?? '').toLowerCase()
					return t === '' || nome.includes(t)
				})
				.filter(e => entidade_pratica_modalidade(e, modalidades_competicao))
				.filter(e => entidade_esta_no_escalao(e, modalidades_competicao, escaloes_competicao))

			setAtletaResults(filtered)
		} catch (error) {
			console.error('Erro ao pesquisar atletas:', error)
		} finally {
			setAtletaLoading(false)
		}
	}

	useEffect(() => {
		if (showAtletaModal) {
			search_atletas_to_inscrever(atletaSearch)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [showAtletaModal, selected_clube_inscrito])

	const handle_atleta_search_change = (e) => {
		const value = e.target.value
		setAtletaSearch(value)
		search_atletas_to_inscrever(value)
	}

	const handleCloseAtletaModal = () => {
		setShowAtletaModal(false)
		setSelectedAtletaToInscrever(null)
		setAtletaSearch('')
	}

	const inscrever_atleta = () => {
		if (!selectedAtletaToInscrever || !selected_clube_inscrito) return

		const nome_atleta = selectedAtletaToInscrever?.info?.name ?? selectedAtletaToInscrever?.name ?? ''
		const numero_atleta = selectedAtletaToInscrever?.info?.numero_atleta ?? selectedAtletaToInscrever?.numero_atleta ?? ''
		const modalidades_competicao = (dados.current.info.modalidades || []).map(m => m.value ?? m)
		const overlapping = get_overlapping_modalidades(selectedAtletaToInscrever, modalidades_competicao)
		const modalidades_label = overlapping.map(v => modalidades_lista.find(o => o.value === v)?.label ?? v).join(', ')
		const escalao_atleta = calcular_escalao_entidade(selectedAtletaToInscrever, modalidades_competicao)

		Swal.fire({
			title: language[lang].inscrever_atleta_title ?? 'Inscrever atleta',
			html: `${language[lang].inscrever_atleta_text ?? 'Confirma inscrever o atleta'} <b>${nome_atleta}</b> ${language[lang].inscrever_clube_text_2 ?? 'nesta competição?'}`,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].associar_confirm ?? 'Inscrever',
			cancelButtonText: language[lang].associar_cancel ?? 'Cancelar'
		}).then((result) => {
			if (result.isConfirmed) {
				const atual = dados.current.info.atletas_inscritos || []
				set_dados(dados.current.info.atletas_inscritos = [
					...atual,
					{
						id: selectedAtletaToInscrever.id,
						label: nome_atleta,
						numero_atleta: numero_atleta,
						escalao: escalao_atleta,
						modalidades: modalidades_label,
						clube_id: selected_clube_inscrito.id,
					}
				])
				handleCloseAtletaModal()
			}
		})
	}

	const remover_atleta_inscrito = (atleta_id) => {
		Swal.fire({
			title: language[lang].remove_title ?? 'Remover',
			text: language[lang].remove_text ?? 'Confirma remover este atleta da competição?',
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].remove_confirm ?? 'Remover',
			cancelButtonText: language[lang].remove_cancel ?? 'Cancelar'
		}).then((result) => {
			if (result.isConfirmed) {
				set_dados(dados.current.info.atletas_inscritos = (dados.current.info.atletas_inscritos || []).filter(a => String(a.id) !== String(atleta_id)))
			}
		})
	}

	// ================= CLASSIFICAÇÕES =================
	const handle_change_classificacao = (clube_id, valor) => {
		set_dados(dados.current.info.classificacoes = {
			...(dados.current.info.classificacoes || {}),
			[clube_id]: valor
		})
	}

	// ================= GRAVAR / ELIMINAR =================
	const handleSubmit = async (e) => {
		e.preventDefault();

		Swal.fire({
			title: is_edit ? (language[lang].edit_title ?? 'Editar') : (language[lang].insert_title ?? 'Inserir'),
			text: is_edit ? (language[lang].edit_text ?? 'Confirma a edição?') : (language[lang].insert_text ?? 'Confirma a inserção?'),
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: is_edit ? (language[lang].edit_confirm ?? 'Confirmar') : (language[lang].insert_confirm ?? 'Confirmar'),
			cancelButtonText: is_edit ? (language[lang].edit_cancel ?? 'Cancelar') : (language[lang].insert_cancel ?? 'Cancelar')
		}).then((result) => {
			if (result.isConfirmed) {

				const requestMethod = is_edit ? reqPUT : reqPOST

				requestMethod(`${api_crud_route}`, dados.current)
					.then(() => {
						files_doc.forEach(async (el_doc) => {
							if (el_doc !== null) {
								await uploadFilesDoc(el_doc.files, el_doc.field)
							}
						})
						set_files_doc([])

						props.history.push(endpoints.list)
					})
					.catch(() => Swal.fire(is_edit ? (language[lang].edit_error ?? 'Erro ao editar') : (language[lang].insert_error ?? 'Erro ao inserir'), '', 'info'))
			}
		})
	}

	function apagar() {
		Swal.fire({
			title: language[lang].delete_title ?? 'Eliminar',
			text: language[lang].delete_text ?? 'Confirma a eliminação?',
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm ?? 'Eliminar',
			cancelButtonText: language[lang].delete_cancel ?? 'Cancelar'
		}).then((result) => {
			if (result.isConfirmed) {
				reqDELETE(api_crud_route + '/', { id: dados.current.id })
					.then(() => { props.history.push(endpoints.list); })
					.catch(() => Swal.fire(language[lang].delete_error ?? 'Erro ao eliminar', '', 'info'))
			}
		})
	};

	return isloading ?

		<Loader />

		:
		isRedirect
			?
			<Redirect to={endpoints.list} replace />
			:

			<main>
				<div className={`dash-cards header`}>
					<h2 className="dash-title">{language[lang].competicao ?? 'Competição'}</h2>
					<p>{language[lang].competicao ?? 'Competição'} / {dados.current.id !== '' ? (language[lang].entity_edit ?? 'Editar') : (language[lang].entity_new ?? 'Novo')}</p>
				</div>

				<div className={`dash-cards body`}>
					<div className="container">
						<div className="row">
							<div className="mb-5 mb-xl-10">

								{/* --- Dados da Competição --- */}
								<div className="card">
									<div className="card-header border-0">
										<div className="card-title m-0">
											<h3 className="fw-bolder m-0">{language[lang].dados_competicao ?? 'Dados da Competição'}</h3>
										</div>
									</div>
									<div className="collapse show">
										<form id="form" onSubmit={handleSubmit}>
											<div className="card-body border-top p-4">

												<div className="row g-3 mb-4">
													<div className="col-md-6">
														<label className="form-label fw-bold fs-6">{language[lang].competicao ?? 'Competição'}</label>
														<input type="text" name="name" value={dados.current.info.name} className="form-control rounded-0" placeholder={language[lang].competicao_placeholder ?? 'Nome da competição'} onChange={handle_change_info} required />
													</div>

													<div className="col-md-6">
														<label className="form-label fw-bold fs-6">{language[lang].tipo_competicao ?? 'Tipo de Competição'}</label>
														<Select
															className="div-select"
															options={tipo_competicao_lista}
															value={tipo_competicao_lista.find(o => o.value === dados.current.info.tipo_competicao) ?? null}
															placeholder={language[lang].select ?? 'Selecione'}
															onChange={change_tipo_competicao}
														/>
													</div>
												</div>

												<div className="row g-3 mb-4">
													<div className="col-md-6">
														<label className="form-label fw-bold fs-6">{language[lang].modalidades ?? 'Modalidades'}</label>
														<Select
															isMulti
															className="div-select"
															options={modalidades_lista}
															value={
																Array.isArray(dados.current.info.modalidades)
																	? dados.current.info.modalidades.map(m => ({ label: m.label ?? m, value: m.value ?? m }))
																	: []
															}
															placeholder={language[lang].select ?? 'Selecione'}
															onChange={change_modalidades}
														/>
													</div>

													<div className="col-md-6">
														<label className="form-label fw-bold fs-6">{language[lang].escaloes ?? 'Escalão(ões)'}</label>
														<Select
															isMulti
															className="div-select"
															options={escaloes_lista}
															value={
																Array.isArray(dados.current.info.escaloes)
																	? dados.current.info.escaloes.map(m => ({ label: m.label ?? m, value: m.value ?? m }))
																	: []
															}
															placeholder={language[lang].select ?? 'Selecione'}
															onChange={change_escaloes}
														/>
													</div>
												</div>

												<div className="row g-3 mb-4">
													<div className="col-md-4">
														<label className="form-label fw-bold fs-6">{language[lang].epoca ?? 'Época'}</label>
														<input type="text" name="epoca" value={dados.current.info.epoca} className="form-control rounded-0" placeholder="2025/2026" onChange={handle_change_info} />
													</div>

													<div className="col-md-4">
														<label className="form-label fw-bold fs-6">{language[lang].inicio ?? 'Início'}</label>
														<input type="date" name="data_inicio" value={dados.current.info.data_inicio} className="form-control rounded-0" onChange={handle_change_info} />
													</div>

													<div className="col-md-4">
														<label className="form-label fw-bold fs-6">{language[lang].fim ?? 'Fim'}</label>
														<input type="date" name="data_fim" value={dados.current.info.data_fim} className="form-control rounded-0" onChange={handle_change_info} />
													</div>
												</div>

												<hr className="my-4" />

												<div className="row g-3 mb-4">
													<div className="col-md-4">
														<label className="form-label fw-bold fs-6">{language[lang].local_competicao ?? 'Local da Competição'}</label>
														<input
															type="text"
															name="localidade_competicao"
															value={dados.current.info.localidade_competicao}
															className="form-control rounded-0"
															placeholder={language[lang].local_placeholder}
															onChange={handle_change_info}
														/>
													</div>

													<div className="col-md-4">
														<label className="form-label fw-bold fs-6">{language[lang].local}</label>
														<input
															type="text"
															name="localidade"
															value={dados.current.info.localidade}
															className="form-control rounded-0"
															placeholder={language[lang].local_placeholder}
															onChange={handle_change_info}
														/>
													</div>

													<div className="col-md-4">
														<label className="form-label fw-bold fs-6">{language[lang].country}</label>
														<input
															type="text"
															name="country"
															value={dados.current.info.country}
															className="form-control rounded-0"
															placeholder={language[lang].country_placeholder}
															onChange={handle_change_info}
														/>
													</div>
												</div>

												<hr className="my-4" />

												<div className="row g-3 mb-4">
													<div className="col-md-4">
														<label className="form-label fw-bold fs-6">{language[lang].responsavel_identificacao ?? 'Identi. Responsável'}</label>
														<input type="text" name="identificacao" value={dados.current.info.responsavel.identificacao ?? ''} className="form-control rounded-0" onChange={handle_change_responsavel} />
													</div>

													<div className="col-md-4">
														<label className="form-label fw-bold fs-6">{language[lang].responsavel_telefone ?? 'Tel Responsável'}</label>
														<PhoneInput
															defaultCountry="PT"
															className="form-control rounded-0"
															value={dados.current.info.responsavel.telefone || null}
															onChange={(valor) => set_dados(dados.current.info.responsavel.telefone = valor)}
														/>
													</div>

													<div className="col-md-4">
														<label className="form-label fw-bold fs-6">{language[lang].responsavel_email ?? 'e-mail Responsável'}</label>
														<input type="email" name="email" pattern={pattern_email} value={dados.current.info.responsavel.email ?? ''} className="form-control rounded-0" onChange={handle_change_responsavel} />
													</div>
												</div>

												<hr className="my-4" />

												<div className="row g-3 mb-4">
													<div className="col-md-6">
														<DocUploadField
															field="regulamento"
															label={language[lang].regulamento ?? 'Regulamento'}
															dados={dados}
															language={language}
															lang={lang}
															onChangeHandlerFilesDoc={onChangeHandlerFilesDoc}
															handleDocRemove={handleDocRemove}
														/>
													</div>

													<div className="col-md-6">
														<label className="form-label fw-bold fs-6">{language[lang].observacoes ?? 'Observações'}</label>
														<textarea name="observacoes" value={dados.current.info.observacoes} className="form-control rounded-0" rows="3" onChange={handle_change_info} />
													</div>
												</div>

											</div>
										</form>
									</div>
								</div>

								{is_edit && (
									<>
										{/* --- Clubes Inscritos --- */}
										<div className="card mt-5">
											<div className="card-header border-0 d-flex justify-content-between align-items-center">
												<div className="card-title m-0">
													<h3 className="fw-bolder m-0">{language[lang].clubes_inscritos ?? 'Clubes Inscritos'}</h3>
												</div>
												<button type="button" className="btn btn-sm btn-primary" onClick={() => setShowClubeModal(true)}>
													<i className="bi bi-plus-circle me-2"></i>
													{language[lang].inscrever_clube ?? 'Inscrever Clube'}
												</button>
											</div>
											<div className="card-body border-top p-4">
												<p className="text-muted small mb-3">
													{language[lang].selecionar_clube_hint ?? 'Selecione um clube na lista abaixo para gerir os atletas inscritos desse clube.'}
												</p>
												<table className="table table-bordered align-middle">
													<thead>
														<tr>
															<th>{language[lang].clube ?? 'Clube'}</th>
															<th></th>
														</tr>
													</thead>
													<tbody>
														{(dados.current.info.clubes_inscritos || []).length > 0 ? (
															dados.current.info.clubes_inscritos.map((el, k) => {
																const is_selected = String(selected_clube_inscrito?.id) === String(el.id)
																return (
																	<tr
																		key={el.id ?? k}
																		onClick={() => set_selected_clube_inscrito(el)}
																		style={{ cursor: 'pointer', backgroundColor: is_selected ? '#e7f3ff' : undefined }}
																	>
																		<td>
																			{is_selected && <i className="bi bi-check-circle-fill me-2" style={{ color: '#0095e8' }}></i>}
																			{el.label}
																		</td>
																		<td className="text-end">
																			<button
																				type="button"
																				className="btn btn-sm"
																				style={{ backgroundColor: '#d9214e', color: '#FFF' }}
																				onClick={(e) => { e.stopPropagation(); remover_clube_inscrito(el.id) }}
																			>
																				{language[lang].remove ?? 'Remover'}
																			</button>
																		</td>
																	</tr>
																)
															})
														) : (
															<tr>
																<td colSpan="2" className="text-center text-muted">{language[lang].sem_registos ?? 'Sem registos'}</td>
															</tr>
														)}
													</tbody>
												</table>
											</div>
										</div>

										{/* --- Atletas Inscritos (só aparece com um clube selecionado) --- */}
										{selected_clube_inscrito && (
											<div className="card mt-5">
												<div className="card-header border-0 d-flex justify-content-between align-items-center">
													<div className="card-title m-0">
														<h3 className="fw-bolder m-0">
															{language[lang].atletas_inscritos ?? 'Atletas Inscritos'} — {selected_clube_inscrito.label}
														</h3>
													</div>
													<button type="button" className="btn btn-sm btn-primary" onClick={() => setShowAtletaModal(true)}>
														<i className="bi bi-plus-circle me-2"></i>
														{language[lang].inscrever_atletas ?? 'Inscrever Atletas'}
													</button>
												</div>
												<div className="card-body border-top p-4">
													<table className="table table-bordered align-middle">
														<thead>
															<tr>
																<th>{language[lang].numero_atleta ?? 'Nº de Atleta'}</th>
																<th>{language[lang].name ?? 'Nome'}</th>
																<th>{language[lang].escalao ?? 'Escalão'}</th>
																<th>{language[lang].modalidades ?? 'Modalidades'}</th>
																<th></th>
															</tr>
														</thead>
														<tbody>
															{(() => {
																const atletas_do_clube = (dados.current.info.atletas_inscritos || [])
																	.filter(el => String(el.clube_id) === String(selected_clube_inscrito.id))

																if (atletas_do_clube.length === 0) {
																	return (
																		<tr>
																			<td colSpan="5" className="text-center text-muted">{language[lang].sem_registos ?? 'Sem registos'}</td>
																		</tr>
																	)
																}

																return atletas_do_clube.map((el, k) => (
																	<tr key={el.id ?? k}>
																		<td>{el.numero_atleta}</td>
																		<td>{el.label}</td>
																		<td>{el.escalao || '-'}</td>
																		<td>{el.modalidades || '-'}</td>
																		<td className="text-end">
																			<button type="button" className="btn btn-sm" style={{ backgroundColor: '#d9214e', color: '#FFF' }} onClick={() => remover_atleta_inscrito(el.id)}>
																				{language[lang].remove ?? 'Remover'}
																			</button>
																		</td>
																	</tr>
																))
															})()}
														</tbody>
													</table>
												</div>
											</div>
										)}

										{/* --- Classificações --- */}
										<div className="card mt-5">
											<div className="card-header border-0">
												<div className="card-title m-0">
													<h3 className="fw-bolder m-0">{language[lang].classificacoes ?? 'Classificações'}</h3>
												</div>
											</div>
											<div className="card-body border-top p-4">
												<table className="table table-bordered align-middle">
													<thead>
														<tr>
															<th>{language[lang].clube ?? 'Clube'}</th>
															<th>{language[lang].classificacao ?? 'Classificação'}</th>
														</tr>
													</thead>
													<tbody>
														{(dados.current.info.clubes_inscritos || []).length > 0 ? (
															dados.current.info.clubes_inscritos.map((el, k) => (
																<tr key={el.id ?? k}>
																	<td>{el.label}</td>
																	<td>
																		<input
																			type="text"
																			className="form-control rounded-0"
																			value={dados.current.info.classificacoes?.[el.id] ?? ''}
																			onChange={(e) => handle_change_classificacao(el.id, e.target.value)}
																			placeholder={language[lang].classificacao_placeholder ?? 'Posição / pontos'}
																		/>
																	</td>
																</tr>
															))
														) : (
															<tr>
																<td colSpan="2" className="text-center text-muted">{language[lang].sem_registos ?? 'Sem registos'}</td>
															</tr>
														)}
													</tbody>
												</table>
											</div>
										</div>
									</>
								)}

								{/* --- Modal: Inscrever Clube --- */}
								{showClubeModal && (
									<div style={modalStyles.modalOverlay} onClick={handleCloseClubeModal}>
										<div style={modalStyles.modalContent} onClick={(e) => e.stopPropagation()}>
											<div style={modalStyles.taskListContainer}>
												<label className="form-label fw-bold fs-6">{language[lang].pesquisar_clube ?? 'Pesquisar Clube'}</label>
												<input
													type="text"
													className="form-control mb-3"
													placeholder={language[lang].pesquisar_entidade_placeholder ?? 'Pesquisar por nome...'}
													value={clubeSearch}
													onChange={handle_clube_search_change}
												/>

												<select
													className="form-select"
													size={8}
													value={selectedClubeToInscrever?.id ?? ''}
													onChange={(e) => {
														const found = clubeResults.find(el => String(el.id) === String(e.target.value))
														setSelectedClubeToInscrever(found ?? null)
													}}
												>
													<option value="">
														{clubeLoading ? (language[lang].loading ?? 'A carregar...') : (language[lang].field_choose ?? 'Selecione')}
													</option>
													{clubeResults.map((el, k) => (
														<option key={el.id ?? k} value={el.id}>
															{el.info?.name ?? el.name}
														</option>
													))}
												</select>
											</div>

											<div style={modalStyles.buttonContainer}>
												<button type="button" onClick={handleCloseClubeModal}>
													{language[lang].cancel ?? 'Cancelar'}
												</button>
												<button
													type="button"
													style={{ ...modalStyles.closeButton, marginLeft: '10px', backgroundColor: color.corPrimaria?.hexa ?? '#0095e8', color: '#FFF' }}
													disabled={!selectedClubeToInscrever}
													onClick={inscrever_clube}
												>
													{language[lang].inscrever_clube ?? 'Inscrever'}
												</button>
											</div>
										</div>
									</div>
								)}

								{/* --- Modal: Inscrever Atletas --- */}
								{showAtletaModal && (
									<div style={modalStyles.modalOverlay} onClick={handleCloseAtletaModal}>
										<div style={modalStyles.modalContent} onClick={(e) => e.stopPropagation()}>
											<div style={modalStyles.taskListContainer}>
												<label className="form-label fw-bold fs-6">{language[lang].pesquisar_atleta ?? 'Pesquisar Atleta'}</label>
												<input
													type="text"
													className="form-control mb-3"
													placeholder={language[lang].pesquisar_entidade_placeholder ?? 'Pesquisar por nome...'}
													value={atletaSearch}
													onChange={handle_atleta_search_change}
												/>

												<select
													className="form-select"
													size={8}
													value={selectedAtletaToInscrever?.id ?? ''}
													onChange={(e) => {
														const found = atletaResults.find(el => String(el.id) === String(e.target.value))
														setSelectedAtletaToInscrever(found ?? null)
													}}
												>
													<option value="">
														{atletaLoading ? (language[lang].loading ?? 'A carregar...') : (language[lang].field_choose ?? 'Selecione')}
													</option>
													{atletaResults.map((el, k) => (
														<option key={el.id ?? k} value={el.id}>
															{el.info?.name ?? el.name}
														</option>
													))}
												</select>
											</div>

											<div style={modalStyles.buttonContainer}>
												<button type="button" onClick={handleCloseAtletaModal}>
													{language[lang].cancel ?? 'Cancelar'}
												</button>
												<button
													type="button"
													style={{ ...modalStyles.closeButton, marginLeft: '10px', backgroundColor: color.corPrimaria?.hexa ?? '#0095e8', color: '#FFF' }}
													disabled={!selectedAtletaToInscrever}
													onClick={inscrever_atleta}
												>
													{language[lang].inscrever_atletas ?? 'Inscrever'}
												</button>
											</div>
										</div>
									</div>
								)}

							</div>
						</div>
					</div>
				</div>

				<div className={'dash-cards footer'}>
					<nav className="navbar bottom-navbar navbar-light">
						<div className="navbar-footer">
							<ul className="navbar-nav float-left"></ul>
							<ul className="navbar-nav float-right">
								<li className="nav-item">
									<Link className="nav-link btn-cancel" to={{ pathname: endpoints.list }}>
										<i className="bi bi-chevron-left me-2"></i>
										<span>{language[lang].back ?? 'Voltar'}</span>
									</Link>
								</li>
								<li className={"nav-item " + (show_delete_button ? '' : 'd-none')}>
									<button type="button" onClick={() => apagar()} className="nav-link btn-delete">
										<i className="bi bi-trash3 me-2"></i>
										<span>{language[lang].delete ?? 'Eliminar'}</span>
									</button>
								</li>
								<li className="nav-item">
									<button type="submit" form="form" className="nav-link">
										<i className="bi bi-floppy me-2"></i>
										<span>{language[lang].save ?? 'Gravar'}</span>
									</button>
								</li>
							</ul>
						</div>
					</nav>
				</div>
			</main>
}

// Campo de upload de PDF reutilizável (mesmo padrão do módulo de Clubes)
function DocUploadField({ field, label, dados, language, lang, onChangeHandlerFilesDoc, handleDocRemove }) {
	const current = dados?.current?.info?.[field];
	const hasFile = Array.isArray(current) && current.length > 0;

	return (
		<div className="p-3 bg-white shadow-sm rounded h-100">
			<label className="form-label fw-bold fs-6 d-block">{label}</label>

			{hasFile ? (
				<div className="d-flex align-items-center justify-content-between">
					<a href={current[0].link} target="_blank" rel="noreferrer" className="text-truncate">
						<i className="bi bi-file-earmark-pdf me-2"></i>
						{current[0].name}
					</a>
					<button
						type="button"
						onClick={() => handleDocRemove(field)}
						className="btn btn-sm ms-2"
						style={{ backgroundColor: '#d9214e', color: '#FFF', border: 'none', borderRadius: '5px' }}
					>
						X
					</button>
				</div>
			) : (
				<div className="text-muted mb-2">{language[lang].noFile ?? 'Sem ficheiro'}</div>
			)}

			<div className="mt-2">
				<input
					type="file"
					accept="application/pdf"
					data-field={field}
					onChange={onChangeHandlerFilesDoc}
					className="d-none"
					id={`doc-upload-${field}`}
				/>
				<label htmlFor={`doc-upload-${field}`} className="btn btn-outline-primary btn-sm">
					{language[lang].doc_choose ?? 'Escolher ficheiro'}
				</label>
			</div>
		</div>
	);
}